<template>
  <div class="container">
    <div style="background: white">
      <!-- 顶部搜索框 -->
      <form action="/">
        <van-search
          v-model="search"
          placeholder="搜索活动"
          @search="onSearch"
        />
      </form>
      <!-- tabs -->
      <div class="tabs">
        <p
          @click="
            tab = 0;
            initrmtj();
          "
          :class="{ active: tab == 0 }"
        >
          热门推荐
        </p>
        <p
          @click="
            tab = 1;
            initwdhd();
          "
          :class="{ active: tab == 1 }"
        >
          我的活动
        </p>
        <p
          @click="
            tab = 2;
            initwdsc();
          "
          :class="{ active: tab == 2 }"
        >
          我的收藏
        </p>
      </div>
    </div>
    <!-- 热门推荐 -->
    <div class="tabcontainer" v-show="tab == 0">
      <van-list
        v-model="listloading"
        :immediate-check="false"
        :finished="listfinished"
        finished-text="没有更多啦"
        @load="listload_more"
      >
        <div
          v-for="(item, index) in list"
          :key="item.id"
          style="margin-bottom: 10px"
          class="main"
          @click="linkid(item.id)"
        >
          <div class="tabflexdiv">
            <div class="left">
              <div class="picdiv">
                <img v-lazy="item.img" alt="" />
                <!-- 状态标签 -->
                <div
                  class="status"
                  v-show="item.zt == 1"
                  :class="{ active01: item.zt == 1 }"
                >
                  <p>报名中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 2"
                  :class="{ active02: item.zt == 2 }"
                >
                  <p>进行中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 3"
                  :class="{ active03: item.zt == 3 }"
                >
                  <p>已完成</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 4"
                  :class="{ active04: item.zt == 4 }"
                >
                  <p>已过期</p>
                </div>
              </div>
            </div>
            <div class="right">
              <div>
                <p class="topic">{{ item.title }}</p>
              </div>
              <!-- <p style="color: #c7b58b; font-weight: bold">
                {{ item.attr_str }}
              </p> -->
              <p>活动范围：{{ item.range_str }}</p>
              <p>活动时间：{{ timeTransevent(item.starttime) }}</p>
              <p>发起组织：{{ item.org_name }}</p>
              <p>
                报名人数：{{ item.count
                }}<span v-if="item.total_count">/{{ item.total_count }}</span
                >人
              </p>
              <!-- <el-button
                v-show="item.isclose == 0 && item.btn != 0"
                type="primary"
                >{{ item.btn_str }}</el-button
              > -->
            </div>
          </div>
          <div class="tabflexdiv tabflexbottom" style="margin-top: 10px">
            <div
              style="display: flex"
              @click.stop="
                showShare = true;
                share(
                  item.title,
                  item.starttime_fmt,
                  item.endtime_fmt,
                  item.range_str,
                  item.address,
                  item.org_name,
                  item.total_count,
                  item.id,
                  item.img
                );
              "
            >
              <img src="static/img/share.png" class="icon" alt="" />
              <span>一键转发</span>
            </div>
            <div style="display: flex" @click.stop="fan(list, item.id, index)">
              <i
                v-show="item.fan == 2"
                style="color: #999999"
                class="el-icon-star-off"
              ></i>
              <i
                v-show="item.fan == 1"
                class="el-icon-star-on"
                style="color: red"
              ></i>
              <span>点击收藏</span>
            </div>
            <div class="tabflexbt" v-show="item.isclose == 0 && item.btn != 0">
              {{ item.btn_str }}
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 我的活动 -->
    <div class="tabcontainer" v-show="tab == 1">
      <van-list
        v-model="myeventloading"
        :finished="myeventfinished"
        :immediate-check="false"
        finished-text="没有更多啦"
        @load="myeventload_more"
      >
        <div
          v-for="(item, index) in myeventlist"
          :key="item.id"
          style="margin-bottom: 10px"
          class="main"
          @click="linkid(item.id)"
        >
          <div class="tabflexdiv">
            <div class="left">
              <div class="picdiv">
                <img v-lazy="item.img" alt="" />
                <!-- 状态标签 -->
                <div
                  class="status"
                  v-show="item.zt == 1"
                  :class="{ active01: item.zt == 1 }"
                >
                  <p>报名中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 2"
                  :class="{ active02: item.zt == 2 }"
                >
                  <p>进行中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 3"
                  :class="{ active03: item.zt == 3 }"
                >
                  <p>已完成</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 4"
                  :class="{ active04: item.zt == 4 }"
                >
                  <p>已过期</p>
                </div>
              </div>
            </div>
            <div class="right">
              <div>
                <p class="topic">{{ item.title }}</p>
              </div>
              <!-- <p style="color: #c7b58b; font-weight: bold">
                {{ item.attr_str }}
              </p> -->
              <p>活动范围：{{ item.range_str }}</p>
              <p>活动时间：{{ timeTransevent(item.starttime) }}</p>
              <p>发起组织：{{ item.org_name }}</p>
              <p>
                报名人数：{{ item.count
                }}<span v-if="item.total_count">/{{ item.total_count }}</span
                >人
              </p>
              <!-- <el-button
                v-show="item.isclose == 0 && item.btn != 0"
                type="primary"
                >{{ item.btn_str }}</el-button
              > -->
            </div>
          </div>
          <div class="tabflexdiv tabflexbottom" style="margin-top: 10px">
            <div
              style="display: flex"
              @click.stop="
                showShare = true;
                share(
                  item.title,
                  item.starttime_fmt,
                  item.endtime_fmt,
                  item.range_str,
                  item.address,
                  item.org_name,
                  item.total_count,
                  item.id,
                  item.img
                );
              "
            >
              <img src="static/img/share.png" class="icon" alt="" />
              <span>一键转发</span>
            </div>
            <div
              style="display: flex"
              @click.stop="fan(myeventlist, item.id, index)"
            >
              <i
                v-show="item.fan == 2"
                style="color: #999999"
                class="el-icon-star-off"
              ></i>
              <i
                v-show="item.fan == 1"
                class="el-icon-star-on"
                style="color: red"
              ></i>
              <span>点击收藏</span>
            </div>
            <div class="tabflexbt" v-show="item.isclose == 0 && item.btn != 0">
              {{ item.btn_str }}
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 我的收藏 -->
    <div class="tabcontainer" v-show="tab == 2">
      <van-list
        v-model="collectionloading"
        :finished="collectionfinished"
        :immediate-check="false"
        finished-text="没有更多啦"
        @load="collectionload_more"
      >
        <div
          v-for="(item, index) in collection"
          :key="item.id"
          style="margin-bottom: 10px"
          class="main"
          @click="linkid(item.id)"
        >
          <div class="tabflexdiv">
            <div class="left">
              <div class="picdiv">
                <img v-lazy="item.img" alt="" />
                <!-- 状态标签 -->
                <div
                  class="status"
                  v-show="item.zt == 1"
                  :class="{ active01: item.zt == 1 }"
                >
                  <p>报名中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 2"
                  :class="{ active02: item.zt == 2 }"
                >
                  <p>进行中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 3"
                  :class="{ active03: item.zt == 3 }"
                >
                  <p>已完成</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 4"
                  :class="{ active04: item.zt == 4 }"
                >
                  <p>已过期</p>
                </div>
              </div>
            </div>
            <div class="right">
              <div>
                <p class="topic">{{ item.title }}</p>
              </div>
              <!-- <p style="color: #c7b58b; font-weight: bold">
                {{ item.attr_str }}
              </p> -->
              <p>活动范围：{{ item.range_str }}</p>
              <p>活动时间：{{ timeTransevent(item.starttime) }}</p>
              <p>发起组织：{{ item.org_name }}</p>
              <p>
                报名人数：{{ item.count
                }}<span v-if="item.total_count">/{{ item.total_count }}</span
                >人
              </p>
              <!-- <el-button
                v-show="item.isclose == 0 && item.btn != 0"
                type="primary"
                >{{ item.btn_str }}</el-button
              > -->
            </div>
          </div>
          <div class="tabflexdiv tabflexbottom" style="margin-top: 10px">
            <div
              style="display: flex"
              @click.stop="
                showShare = true;
                share(
                  item.title,
                  item.starttime_fmt,
                  item.endtime_fmt,
                  item.range_str,
                  item.address,
                  item.org_name,
                  item.total_count,
                  item.id,
                  item.img
                );
              "
            >
              <img src="static/img/share.png" class="icon" alt="" />
              <span>一键转发</span>
            </div>
            <div
              style="display: flex"
              @click.stop="fan(collection, item.id, index)"
            >
              <i
                v-show="item.fan == 2"
                style="color: #999999"
                class="el-icon-star-off"
              ></i>
              <i
                v-show="item.fan == 1"
                class="el-icon-star-on"
                style="color: red"
              ></i>
              <span>点击收藏</span>
            </div>
            <div class="tabflexbt" v-show="item.isclose == 0 && item.btn != 0">
              {{ item.btn_str }}
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon01.png"
          class="icon"
          alt=""
          @click="urlchange('/')"
        />
        <p>首页</p>
      </div>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon02.png"
          class="icon"
          alt=""
          @click="urlchange('/cfshow')"
        />
        <p>澄风show</p>
      </div>
      <van-popover
        v-model="showPopover"
        trigger="click"
        :actions="actions"
        @select="onSelect"
        placement="top"
      >
        <template #reference>
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/icon05.png"
            style="width: 45px; height: 35px"
            alt=""
          />
        </template>
      </van-popover>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icona03.png"
          class="icon"
          alt=""
        />
        <p style="color: #1646c0">活动中心</p>
      </div>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon04.png"
          class="icon"
          alt=""
          @click="urlchange('/center')"
        />
        <p>我的家园</p>
      </div>
    </div>
    <!-- 分享面板 -->
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onShareSelect"
    />
    <!-- 分享海报 -->
    <vue-canvas-poster
      :widthPixels="1000"
      :painting="painting"
      @success="success"
      @fail="fail"
    >
    </vue-canvas-poster>
    <van-overlay :show="showposter" @click="showposter = false">
      <img
        class="poster"
        @touchend.prevent="isAndroid && saveimg()"
        saveImage="true"
        :src="posterimg"
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
export default {
  name: "eventcenterdetail",
  data() {
    return {
      showpic: false,
      isAndroid: false,
      loop: 0,
      status: 0,
      tab: 0,
      list: [],
      myeventlist: [],
      collection: [],
      top: {},
      listloading: false,
      listfinished: false,
      listpage: 1,
      myeventloading: false,
      myeventfinished: false,
      myeventpage: 1,
      collectionloading: false,
      collectionfinished: false,
      collectionpage: 1,
      appId: "2312",
      url: "",
      showPopover: false,
      actions: [
        { text: "发布报告", icon: "notes-o", className: "0" },
        { text: "发布心愿", icon: "exchange", className: "1" },
        { text: "我的收藏", icon: "like-o", className: "2" },
      ],
      search: "",
      showShare: false,
      options: [
        { name: "分享海报", icon: "poster" },
        { name: "其他", icon: "link" },
      ],
      painting: {
        width: `${document.documentElement.clientWidth}px`,
        height: `${document.documentElement.clientWidth * 1.6}px`,
        background: "#fff",
        views: [
          {
            //头像
            type: "image",
            id: "avater",
            url: "",
            css: {
              top: "50px",
              left: `${document.documentElement.clientWidth / 3.1}px`,
              width: `${document.documentElement.clientWidth / 2.8}px`,
              height: `${document.documentElement.clientWidth / 3.5}px`,
            },
          },
          {
            //text1 title
            type: "text",
            text: "",
            css: {
              top: [
                `${document.documentElement.clientWidth / 7 + 20}px`,
                "avater",
              ],
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "20px",
              textAlign: "center",
              maxLines: 1,
            },
          },
          {
            //text2 starttime
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 120}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text3 endtime
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 144}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text4 range
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 168}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text5 address
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 192}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
              maxLines: 1,
            },
          },
          {
            //text6 org
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 216}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
              maxLines: 1,
            },
          },
          {
            //text6 count
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 240}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //rect
            type: "rect",
            text: "",
            css: {
              bottom: `100px`,
              width: `${document.documentElement.clientWidth - 40}px`,
              left: "20px",
              height: "1px",
              color: "grey",
            },
          },
          {
            //qrcode
            type: "qrcode",
            content: "",
            css: {
              bottom: "20px",
              width: "60px",
              height: "60px",
              left: "20px",
            },
          },
          {
            //icon
            type: "image",
            url: "",
            css: {
              bottom: "20px",
              right: "20px",
              width: "60px",
              height: "60px",
            },
          },
          {
            //text
            type: "text",
            text: "①长按保存图片到相册",
            css: {
              bottom: "64px",
              width: `${document.documentElement.clientWidth - 180}px`,
              fontSize: "12px",
              left: "90px",
              color: "#a1a1a1",
            },
          },
          {
            //text
            type: "text",
            text: "②打开最江阴APP扫一扫",
            css: {
              bottom: "24px",
              width: `${document.documentElement.clientWidth - 180}px`,
              fontSize: "12px",
              left: "90px",
              color: "#a1a1a1",
            },
          },
        ],
      },
      posterimg: "",
      showposter: false,
      currentshareevent: {},
    };
  },
  created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    if (isAndroid) {
      this.isAndroid = true;
    }
    var that = this;
    //app
    this.url = "//zhuzhan.ijiangyin.com/siteapp/appClient/sign";
    zjyapi.init({
      appId: that.appId,
      error: function (code, ret) {
        //失败回调,默认
        alert("初始化失败");
      },
      success: function success(ret) {
        console.log("初始化成功");
      },
    });

    /* 树附近数据 */
    this.$axios({
      method: "post",
      url: "/api/task/index",
      data: this.qs.stringify({
        token: sessionStorage.getItem("wmtoken"),
      }),
    }).then((res) => {
      //console.log(res.data);
      if (res.data.code == 0) {
        this.top = res.data.data.count;
      }
    });
    /* 热门推荐 */
    this.initrmtj();
    /* 我的活动 */
    this.initwdhd();
    /* 我的收藏 */
    this.initwdsc();
  },
  mounted() {},
  methods: {
    saveimg() {
      //console.log("调用saveimage");
      zjyapi.saveImage(true);
    },
    changesharepic() {
      this.$axios({
        method: "post",
        url: "/api/common/uploadbaseimg",
        data: this.qs.stringify({
          base_img: this.posterimg,
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          this.posterimg = res.data.data.url;
          //this.showposter = true;
        } else {
          //this.$toast('生成海报失败，请重试');
        }
      });
    },
    /* poster */
    share(title, starttime, endtime, range, address, org, count, id, img) {
      this.currentshareevent.title = title;
      this.currentshareevent.starttime = starttime;
      this.currentshareevent.endtime = endtime;
      this.currentshareevent.range = range;
      this.currentshareevent.address = address;
      this.currentshareevent.org = org;
      this.currentshareevent.count = count;
      this.currentshareevent.id = id;
      this.currentshareevent.img = img;
    },
    beginPoster() {
      //console.log(this.currentshareevent.img);
      this.$set(this.painting.views[0], "url", this.currentshareevent.img);
      this.$set(this.painting.views[1], "text", this.currentshareevent.title);
      this.$set(
        this.painting.views[2],
        "text",
        "活动开始时间：" + this.currentshareevent.starttime
      );
      this.$set(
        this.painting.views[3],
        "text",
        "活动结束时间：" + this.currentshareevent.endtime
      );
      this.$set(
        this.painting.views[4],
        "text",
        "活动范围：" + this.currentshareevent.range
      );
      this.$set(
        this.painting.views[5],
        "text",
        "活动地址：" + this.currentshareevent.address
      );
      this.$set(
        this.painting.views[6],
        "text",
        "发起组织：" + this.currentshareevent.org
      );
      this.$set(
        this.painting.views[7],
        "text",
        "参与名额：" + this.currentshareevent.count + "人"
      );
      this.$set(
        this.painting.views[9],
        "content",
        "https://www.jywmsj.cn/h5/#/detail?id=" + this.currentshareevent.id
      );
      this.$set(
        this.painting.views[10],
        "url",
        "https://pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
      );
      this.$toast("生成海报中");
      this.showposter = true;
    },
    success(src) {
      //console.log(src);
      this.posterimg = src;
      this.changesharepic();
    },
    fail(err) {
      //console.log("fail", err);
    },
    /* posterend */
    onShareSelect(option) {
      //console.log(option);
      switch (option.icon) {
        case "poster":
          //console.log("poster");
          this.beginPoster();
          break;
        case "link":
          this.showShare = false;
          this.zhuanfa(
            this.currentshareevent.title,
            this.currentshareevent.id,
            this.currentshareevent.img,
            this.currentshareevent.starttime,
            this.currentshareevent.endtime,
            this.currentshareevent.range
          );
        default:
          break;
      }
      this.showShare = false;
    },
    onSearch() {
      this.initrmtj();
      this.initwdhd();
      this.initwdsc();
      this.list = [];
      this.myeventlist = [];
      this.collection = [];
      this.listpage = 1;
      this.myeventpage = 1;
      this.collectionpage = 1;
      this.listfinished = false;
      this.myeventfinished = false;
      this.collectionfinished = false;
    },
    onSelect(action) {
      //console.log(action);
      if (action.className == 0) {
        this.$router.push("/mywishlist");
      }
      if (action.className == 1) {
        this.$router.push("/applywish");
      }
      if (action.className == 2) {
        this.$router.push("/myfav");
      }
    },
    initrmtj() {
      this.listpage = 1;
      this.listfinished = false;
      this.listloading = false;
      this.list = [];
      this.$axios({
        method: "post",
        url: "/api/task/hot_list",
        data: this.qs.stringify({
          keyword: this.search,
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          this.list = res.data.data.list;
          for (let i in res.data.data.list) {
            this.list[i].fan = 2;
            if (this.list[i].fav) {
              this.list[i].fan = 1;
            }
            switch (res.data.data.list[i].type) {
              case 1:
                this.list[i].type = "志愿者活动";
                break;
              case 2:
                this.list[i].type = "心愿任务";
                break;
              default:
                break;
            }
          }
          this.$forceUpdate();
        }
      });
    },
    initwdhd() {
      this.myeventlist = [];
      this.myeventpage = 1;
      this.myeventfinished = false;
      this.myeventloading = false;
      this.$axios({
        method: "post",
        url: "/api/task/my_list",
        data: this.qs.stringify({
          keyword: this.search,
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          this.myeventlist = res.data.data.list;
          for (let i in res.data.data.list) {
            this.myeventlist[i].fan = 2;
            if (this.myeventlist[i].fav) {
              this.myeventlist[i].fan = 1;
            }
            switch (res.data.data.list[i].type) {
              case 1:
                this.myeventlist[i].type = "志愿者活动";
                break;
              case 2:
                this.myeventlist[i].type = "心愿任务";
                break;
              default:
                break;
            }
          }
          this.$forceUpdate();
        }
      });
    },
    initwdsc() {
      this.collection = [];
      this.collectionpage = 1;
      this.collectionfinished = false;
      this.collectionloading = false;
      this.$axios({
        method: "post",
        url: "/api/task/fav_list",
        data: this.qs.stringify({
          keyword: this.search,
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          this.collection = res.data.data.list;
          for (let i in res.data.data.list) {
            this.collection[i].fan = 2;
            if (this.collection[i].fav) {
              this.collection[i].fan = 1;
            }
            switch (res.data.data.list[i].type) {
              case 1:
                this.collection[i].type = "志愿者活动";
                break;
              case 2:
                this.collection[i].type = "心愿任务";
                break;
              default:
                break;
            }
          }
          this.$forceUpdate();
        }
      });
    },
    zhuanfa(title, id, img, starttime, endtime, address) {
      this.openShare(
        title,
        "https://www.jywmsj.cn/h5/#/detail?id=" + id,
        "https://www.jywmsj.cn/" + img,
        starttime,
        endtime,
        address
      );
    },
    listload_more() {
      this.listpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/task/hot_list",
            data: that.qs.stringify({
              keyword: that.search,
              page: that.listpage,
            }),
          })
          .then((res) => {
            //console.log(res.data);
            if (res.data.code == 0) {
              for (let i in res.data.data.list) {
                res.data.data.list[i].fan = 2;
                if (res.data.data.list[i].fav) {
                  res.data.data.list[i].fan = 1;
                }
                switch (res.data.data.list[i].type) {
                  case 1:
                    res.data.data.list[i].type = "志愿者活动";
                    break;
                  case 2:
                    res.data.data.list[i].type = "心愿任务";
                    break;
                  default:
                    break;
                }
              }
              that.list = that.list.concat(res.data.data.list);
            }
            that.listloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listfinished = true;
            } else {
              that.listfinished = false;
            }
          });
      }, 500);
    },
    myeventload_more() {
      this.myeventpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/task/my_list",
            data: that.qs.stringify({
              keyword: that.search,
              page: that.myeventpage,
            }),
          })
          .then((res) => {
            //console.log(res.data);
            if (res.data.code == 0) {
              for (let i in res.data.data.list) {
                res.data.data.list[i].fan = 2;
                if (res.data.data.list[i].fav) {
                  res.data.data.list[i].fan = 1;
                }
                switch (res.data.data.list[i].type) {
                  case 1:
                    res.data.data.list[i].type = "志愿者活动";
                    break;
                  case 2:
                    res.data.data.list[i].type = "心愿任务";
                    break;
                  default:
                    break;
                }
              }
              that.myeventlist = that.myeventlist.concat(res.data.data.list);
            }
            that.myeventloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.myeventfinished = true;
            } else {
              that.myeventfinished = false;
            }
          });
      }, 500);
    },
    collectionload_more() {
      this.collectionpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/task/fav_list",
            data: that.qs.stringify({
              keyword: that.search,
              page: that.collectionpage,
            }),
          })
          .then((res) => {
            //console.log(res.data);
            if (res.data.code == 0) {
              for (let i in res.data.data.list) {
                res.data.data.list[i].fan = 2;
                if (res.data.data.list[i].fav) {
                  res.data.data.list[i].fan = 1;
                }
                switch (res.data.data.list[i].type) {
                  case 1:
                    res.data.data.list[i].type = "志愿者活动";
                    break;
                  case 2:
                    res.data.data.list[i].type = "心愿任务";
                    break;
                  default:
                    break;
                }
              }
              that.collection = that.collection.concat(res.data.data.list);
            }
            that.collectionloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.collectionfinished = true;
            } else {
              that.collectionfinished = false;
            }
          });
      }, 500);
    },
    linkid(id) {
      this.$router.push({
        name: "detail",
        query: {
          id: id,
        },
      });
    },
    linkto(url) {
      this.$router.push(url);
    },
    urlchange(url) {
      if (url == "/center") {
        if (!sessionStorage.getItem("wmtoken")) {
          this.$toast("请先加入志愿者");
          return;
        }
      }
      this.$router.push(url);
    },
    //收藏
    fan(list, id, index) {
      //console.log(index);
      //未收藏状态
      if (list[index].fan == 2) {
        this.$axios({
          method: "post",
          url: "/api/task/fav",
          data: this.qs.stringify({
            task_id: id,
            type: 1,
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].fan = 1;
            this.$forceUpdate();
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        this.$axios({
          method: "post",
          url: "/api/task/fav",
          data: this.qs.stringify({
            task_id: id,
            type: 2,
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].fan = 2;
            this.$forceUpdate();
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      //console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          //console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    addzhuanfanum() {
      this.$axios({
        method: "post",
        url: "/api/report/zhuanfa",
        data: {},
      }).then((res) => {});
    },
    openShare: function (title, url, imgUrl, starttime, endtime, address) {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.openShare({
          sign: sign,
          params: {
            title: title,
            content: `
            ${starttime}-${endtime}
            ${address}
            ${title}
            `,
            url: url, //分享地址
            imgUrl: imgUrl, //分享图标地址
          },
          success: function (ret) {
            //console.log("分享成功：" + ret);
            var data = JSON.parse(ret);
            that.addzhuanfanum();
            //console.log(ret);
            //console.log(data);
          },
          error: function (error) {
            //console.log("分享失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //app相关end
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f5f6f7;
}
img {
  width: 100%;
  display: block;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  font-size: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  color: #434343;
  background: white;
}
/* .footer p {
  font-size: 0.289855rem;
} */
.footer div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 20%;
}
.icon {
  width: 20px;
  height: 20px;
}
.font {
  color: white;
  font-size: 14px;
  margin: 5px;
  position: absolute;
  top: 10px;
  left: 10px;
  font-weight: bold;
}
.flex {
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bts {
  width: 90%;
  margin: 0 auto;
  position: relative;
  height: 70px;
  bottom: 80px;
}
.bt {
  color: white;
  position: relative;
  width: 65%;
}
.bt p {
  position: absolute;
  bottom: 6vw;
  text-align: center;
  width: 100%;
}

.tabs {
  width: 90%;
  margin: 0 auto;
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  font-size: 14px;
}
.tabs p {
  width: 33%;
  text-align: center;
  line-height: 36px;
  margin: 0 20px;
}
.active {
  color: #1646c0;
  border-bottom: 1px solid #1646c0;
  background: white;
}
.tabcontainer {
  padding: 12px;
  margin-bottom: 50px;
  background: #f5f6f7;
}
.tabflexdiv {
  display: flex;
  flex: 1;
}
.tabflexdiv .icon {
  width: 16px;
  height: 16px;
}
.tabflexbottom {
  align-items: center;
}
.tabflexbottom span {
  color: #999999;
  font-size: 12px;
  margin-right: 19px;
}
.tabflexbt {
  margin-left: auto;
  color: #1646c0;
  border: 1px solid #1646c0;
  font-size: 14px;
  height: 24px;
  line-height: 24px;
  padding: 0 12px;
  border-radius: 12px;
}
.left {
  margin-right: 12px;
}
.left img {
  width: 76px;
  height: 101px;
  object-fit: contain;
  background: white;
  flex-shrink: 0;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
}
.tabcontainer .right {
  display: flex;
  flex-direction: column;
  line-height: 1.3em;
  font-size: 12px;
  color: #666666;
}
/* .tabcontainer .right p {
  font-size: 0.338164rem;
} */
.tabcontainer .right .el-button {
  width: 60%;
  align-self: flex-end;
  padding: 10px;
  margin-top: auto;
}
.main {
  padding: 12px;
  background: white;
  border-radius: 8px;
}
.label {
  background: #a5ef99;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 3px 10px;
  margin-right: -11px;
  white-space: nowrap;
  height: 20px;
  line-height: 20px;
}
.picdiv {
  position: relative;
  overflow: hidden;
}
.status {
  font-size: 12px;
  color: white;
  font-weight: bold;
  background: orange;
  text-align: center;
  position: absolute;
  top: 3px;
  right: 3px;
  padding: 4px;
  border-radius: 4px;
}
.active01 {
  background: #f5a623;
}
.active02 {
  background: #09bd65;
}
.active03 {
  background: #e60013;
}
.active04 {
  background: grey;
}
.topic {
  word-break: break-all;
  margin-bottom: 7px;
  color: #333333;
  font-weight: 600;
  font-size: 16px;
}
.poster {
  width: 80%;
  border-radius: 10px;
  margin: auto;
  margin-top: 10vw;
  -webkit-touch-callout: default;
}

.icon {
  width: 20px;
  height: 20px;
}
.btshare {
  background: #cab586;
  color: white;
  border-radius: 20px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 20px auto;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/eventcenterdetail.vue